import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/pages/home/HomePage.js");
